import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const UnsavedChangesAlert = ({ show, onCancel, onConfirm }) => {
    const { t } = useTranslation();

    if (!show) return null;

    return (
        <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>
            <Alert
                variant='filled'
                severity="warning"
                sx={{ mt: 2 }}
                icon={<WarningAmberIcon />}
                action={
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            onClick={onCancel}
                            color="inherit"
                            size="small"
                            variant='text'
                            disableElevation
                        >
                            {t('general.alerts.unsaved_changes.buttons.yes')}
                        </Button>
                        <Button
                            onClick={onConfirm}
                            color="inherit"
                            size="small"
                            variant='text'
                            disableElevation
                        >
                            {t('general.alerts.unsaved_changes.buttons.no')}
                        </Button>
                    </Box>
                }
            >
                <AlertTitle>
                    {t('general.alerts.unsaved_changes.title')}
                </AlertTitle>
                {t('general.alerts.unsaved_changes.message')}
            </Alert>
        </Box>
    );
};

export default UnsavedChangesAlert;